import React, { Component } from 'react';
import { Navigation } from '../../navigation/react-redux-nav';
import MuiRaisedButton from 'material-ui/RaisedButton';
import Icon, { NAMES } from '@ifit/react-icons';

import styles from '../../shared-styles';
import './index.css';

export default class PersonalizeStart extends Component {
  render() {
    return (
      <div className="personalize-start-page">
        <div className="start-content">
          <h1>Next our trainers need to get to know you so they can build your fitness&nbsp;plan.</h1>
          <div className="navigation-button-container">
            <Navigation.Forward>
              <MuiRaisedButton
                className="button"
                label="Get Started"
                primary={ true }
                style={{ ...styles.buttonStyle, width: '251px' }}
                buttonStyle={ styles.buttonBorderStyle }
                labelStyle={ styles.buttonLabelStyle }
              >
                <Icon
                  className="right-arrow"
                  name={ NAMES.ARROW_RIGHT_LONG }
                  color={ 'white' }
                  size={ 24 }
                  unitSize="px"
                />
              </MuiRaisedButton>
            </Navigation.Forward>
          </div>
        </div>
      </div>
    );
  }
}
